import {useEffect, useState} from 'react';
import apiClient2 from "../../../../api/apiClient2";
import apiPaths from "../../../../api/endpoints";
import {ConversationBlock} from '../config';

interface UseChatConversationsResult {
  showChatConvo: boolean;
  blocks: ConversationBlock[];
  loading: boolean;
}

const useChatConversations = (): UseChatConversationsResult => {
  const [loading, setLoading] = useState(true);
  const [showChatConvo, setShowChatConvo] = useState(false);
  const [blocks, setBlocks] = useState<ConversationBlock[]>([]);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await apiClient2.get(apiPaths.CHAT_CONVERSATIONS);
        const {data} = response;
        setShowChatConvo(data?.showChatConvo ?? false);
        setBlocks(data?.data?.blocks ?? []);
      } catch {
        setShowChatConvo(false);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, []);

  return {showChatConvo, blocks, loading};
};

export default useChatConversations;
